// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-tiers-preview[data-v-657ab9fe] {\n  font-size: 0.9rem;\n}", ""]);
// Exports
module.exports = exports;
